<template>
	<dashboard-panel
		title="Channels"
		:edit-mode="editMode"
		popout-url="/app/channelList.html"
		:popout-width="400"
		:popout-height="700"
		@remove="$emit('remove')"
	>
		<div class="h-100 d-flex flex-column overflow-hidden">
			<div class="flex-fill overflow-auto">
				<channel-list @updated="$emit('bottom-out')" @edit="$refs.channelModal.showEdit($event.service_id, $event.token)" ref="channelList"></channel-list>
			</div>
			<div class="p-2">
				<b-button class="w-100" variant="primary" @click="$refs.channelModal.show()">Add channel</b-button>
			</div>
		</div>
		<channel-modal ref="channelModal" @saved="onChannelSaved"></channel-modal>
	</dashboard-panel>
</template>

<script>
import DashboardPanel from '../DashboardPanel.vue';
import ChannelList from '../ChannelList.vue';
import ChannelModal from '../Channel/Modal/ChannelModal';

export default {
	name: 'ChannelsPanel',
	components: { DashboardPanel, ChannelList, ChannelModal },
	props: {
		editMode: { type: Boolean, default: false },
		// Bumped by the parent to restart the channel poller (e.g. after scheduling).
		refreshToken: { type: Number, default: 0 },
		// The scheduled time to highlight in the channel list, set when a schedule is created.
		schedulingAt: { type: String, default: null },
	},
	watch: {
		refreshToken() { this.$refs.channelList?.channelPoller?.start(); },
		schedulingAt(at) { if(at) this.$refs.channelList?.markScheduling?.(at); },
	},
	mounted() {
		window.addEventListener('message', this.onMessage);
	},
	beforeDestroy() {
		window.removeEventListener('message', this.onMessage);
	},
	methods: {
		onMessage(event) {
			if(event.origin !== process.env.VUE_APP_PIPIPUPUBASE) return;
			if(event.data.type == 'openChannelEdit')
				this.$refs.channelModal.showEdit(event.data.serviceId, event.data.channelToken);
		},
		onChannelSaved() {
			this.$refs.channelList?.channelPoller?.start();
			this.$emit('updated');
		},
	},
};
</script>
